const WorkoutActionTypes = {
  TOGGLE_EXERCISE: 'TOGGLE_EXERCISE',
  FETCH_RANDOM_WORKOUT_START: 'FETCH_RANDOM_WORKOUT_START',
  FETCH_RANDOM_WORKOUT_SUCCESS: 'FETCH_RANDOM_WORKOUT_SUCCESS',
  FETCH_RANDOM_WORKOUT_FAILURE: 'FETCH_RANDOM_WORKOUT_FAILURE',
  SET_ACTIVE_EXERCISE: 'SET_ACTIVE_EXERCISE',
  RESET_TO_INITIAL_STATE: 'RESET_TO_INITIAL_STATE',
  PREVIEW_NEXT_EXERCISE: 'PREVIEW_NEXT_EXERCISE',
  RESET_NEXT_EXERCISE: 'RESET_NEXT_EXERCISE',
  TOGGLE_WEIGHTS: 'TOGGLE_WEIGHTS',
};

export default WorkoutActionTypes;
